"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ariaLiveClassNames: function() {
        return ariaLiveClassNames;
    },
    useAriaLiveStyles_unstable: function() {
        return useAriaLiveStyles_unstable;
    }
});
const _react = require("@griffel/react");
const ariaLiveClassNames = {
    assertive: 'fui-AriaLive__assertive',
    polite: 'fui-AriaLive__polite'
};
/**
 * Styles for the root slot
 */ const useResetStyles = /*#__PURE__*/ (0, _react.__resetStyles)("rrd10u0", null, [
    ".rrd10u0{clip:rect(0px, 0px, 0px, 0px);height:1px;margin:-1px;overflow:hidden;padding:0px;width:1px;position:absolute;}"
]);
const useAriaLiveStyles_unstable = (state)=>{
    'use no memo';
    const visuallyHidden = useResetStyles();
    state.assertive.className = (0, _react.mergeClasses)(visuallyHidden, ariaLiveClassNames.assertive, state.assertive.className);
    state.polite.className = (0, _react.mergeClasses)(visuallyHidden, ariaLiveClassNames.polite, state.polite.className);
    return state;
}; //# sourceMappingURL=useAriaLiveStyles.styles.js.map
